export default "__VITE_ASSET__DiHVhbSk__"